import { render, staticRenderFns } from "./ClinicShortVideoCard.vue?vue&type=template&id=18b812d1&scoped=true"
import script from "./ClinicShortVideoCard.vue?vue&type=script&lang=js"
export * from "./ClinicShortVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ClinicShortVideoCard.vue?vue&type=style&index=0&id=18b812d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b812d1",
  null
  
)

export default component.exports